import React, { useContext } from "react";
import sld from "../../images/sld/Rectangle.svg";
import Ecc from "../../components/PVHYBRIDIZATION/Ecc";
import Busbar from "../../components/ReusableSvg/Busbar";
import Utility from "../../components/GRIDCONNECTED/Utility";
import EV from "../../components/GRIDCONNECTED/EV";
import PV2 from "../../components/GRIDCONNECTED/PV2";
import PV3 from "../../components/GRIDCONNECTED/PV3";
import Load from "../../components/GRIDCONNECTED/Load";
import PV from "../../components/ISLANDABLE/PV1";
// import Battery from "../../components/ISLANDABLE/Battery";
import Battery from "../../components/PvBessNr/Battery";
import embLabels from "../../config/emb-labels-en.json";
import { DesignAssetContext } from "../CustomHooks/ContextApi";
import Linebar from "../../components/GRIDCONNECTED/Linebar";
import LoadPvBess from "../../components/GensetPvBess/LoadPvBess";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const GridConnectedRosette = () => {
  const projectTypeValue = useProjectTypeValue();
   const { CBAssetList, CBLoadList, CBEVList, sldLoadCompleted,switchboardType, siteType, count, loadSide, isExportOptimization } =
    useContext(DesignAssetContext);
    const areAllConfigured = () =>{
    const loadList = CBLoadList.filter(load => !load.uiData.isRemoteLoad);
    return loadList.every(item => item.uiData.configured);
  }
  const multipleLoadsAllowed = siteType === "GRID_CONNECTED" && isExportOptimization && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue);
  const loadXPosition = () => {
    if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
     if(multipleLoadsAllowed){
        if (count?.derCount === 5) {
        if (count?.evCount === 1) {
          return 100;
        } else {
          return  180;
        }
         }else if(count?.derCount === 4){
          if (count?.evCount === 1) {
          return 160;
        } else {
          return  220;
        }
         }else if(count?.derCount === 3){
           if (count?.evCount === 1) {
          return 100;
        } else {
          return  180;
        }
         }
     }else{
       if (count?.derCount === 5) {
        if (count?.evCount === 1) {
          return 60;
        } else {
          return loadSide === "LOAD_SIDE" ? 90 : 140;
        }
      } else if (count?.derCount === 4) {
        if (count?.evCount === 1) {
          return 60;
        } else {
          return loadSide === "LOAD_SIDE" ? 90 : 140;
        }
      } else if (count?.evCount === 1) {
        return 60;
      } else {
        return loadSide === "LOAD_SIDE" ? 90 : 140;
      }
     }
     
    } else {
     if(multipleLoadsAllowed){
       if (count?.derCount === 5) {
        if (count?.evCount === 1) {
          return 370;
        } else {
          return 300;
        }
      } else if (count?.derCount === 4) {
        if (count?.evCount === 1) {
          return 340;
        } else {
          return 290;
        }
      }else if (count?.derCount === 3) {
        if (count?.evCount === 1) {
          return 340;
        } else {
          return 290;
        }
      } else if (count?.evCount === 1) {
        return 300;
      } else {
        return 250;
      }
     }else{
       if (count?.derCount === 5) {
        if (count?.evCount === 1) {
          return 370;
        } else {
          return 270;
        }
      } else if (count?.derCount === 4) {
        if (count?.evCount === 1) {
          return 270;
        } else {
          return 200;
        }
      } else if (count?.evCount === 1) {
        return 250;
      } else {
        return 140;
      }
     }
    }
  }  
  const loadYposition = () => {
    if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
      if(multipleLoadsAllowed){
        return loadSide === "LOAD_SIDE" ? -20 : 40;
      }else{
        return 0;
      }
    }else{
     if(multipleLoadsAllowed){
        return  70;
     }else{
      return 0;
     }
    }
    
  }
  const evXPosition = () => {
    if(multipleLoadsAllowed){
       if (count?.derCount === 5) {
      if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
        return multipleLoadsAllowed ? 190 : 150;
      } else {
        return 100;
      }
    } else if (count?.derCount === 4) {
      if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
        return 80;
      } else {
        return 100;
      }
    } else {
      return switchboardType === embLabels?.EXISTING_SWITCHBOARD ? 80 : 110;
    }
    }else{
       if (count?.derCount === 5) {
      if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
        return multipleLoadsAllowed ? 190 : 150;
      } else {
        return 100;
      }
    } else if (count?.derCount === 4) {
      if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
        return 40;
      } else {
        return 100;
      }
    } else {
      return switchboardType === embLabels?.EXISTING_SWITCHBOARD ? 40 : 110;
    }
    }
   
  };
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
        <svg viewBox="0 0 1300 800">
          <g>
            <svg x="0" y="0" viewBox="0 0 1300 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>

            <g
              id="components-sld"
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
              <Ecc />
             { switchboardType === embLabels?.EXISTING_SWITCHBOARD && siteType === "GRID_CONNECTED" && <Linebar />}
              <Busbar secondBusbar={switchboardType === embLabels?.EXISTING_SWITCHBOARD && siteType === "GRID_CONNECTED"?true:false} />
              <Utility />
              {CBAssetList[2]?.uiData?.status && <Battery />}
              {CBAssetList[3]?.uiData?.status && <PV />}
              {CBAssetList[4]?.uiData?.status && <PV2 />}
              {CBAssetList[5]?.uiData?.status && <PV3 />}

              <svg x={loadXPosition()} y={loadYposition()}>
              {
             isExportOptimization === false ?  CBLoadList.map((loadData, key) => (
                <Load
                  key={loadData?.uiData?.xAxis}
                  load={loadData?.uiData}
                  loadName={loadData?.configData?.name}
                  index={key}
                />
              )) :

               <LoadPvBess
                      loadLength = {count}
                        configured = {areAllConfigured()}
                      />
              }
              </svg>
          <svg x={evXPosition()} y="0">
              {CBEVList.map(
                (cbData, key) =>
                  cbData?.uiData?.status && (
                    <EV
                      key={cbData?.configData?.name}
                      index={key}
                      status={cbData?.uiData?.status}
                    />
                  )
              )}
              </svg>
            </g>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default GridConnectedRosette;
